export default __webpack_public_path__ + "static/media/GitBook_black.cb545b10.png";